import PageForgotPasswordConfirmCode from "./PageForgotPasswordConfirmCode.vue";
export default PageForgotPasswordConfirmCode;
